module.exports = __webpack_public_path__ + "img/report-preview.83a5aa67.png";